(() => {
  if (window.__eoneLazyCardVariants) return;
  window.__eoneLazyCardVariants = true;
  const cache = new Map();

  function hydrate(picker) {
    const url = new URL(picker.dataset.url, location.origin);
    url.search = '';
    url.hash = '';
    url.pathname += '.js';
    const key = url.href;
    if (!cache.has(key)) {
      cache.set(key, fetch(key, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) })
        .then(response => {
          if (!response.ok) throw new Error('Product options unavailable');
          return response.json();
        })
        .then(product => {
          if (!Array.isArray(product.variants) || !product.variants.length) throw new Error('Missing product options');
          return product.variants.map(variant => ({
            ...variant,
            featured_media: variant.featured_media || (product.media || []).find(media => media.id === variant.featured_image?.id) || null
          }));
        })
        .catch(error => { cache.delete(key); throw error; }));
    }
    return cache.get(key).then(variants => {
      picker.querySelector('script[type="application/json"]').textContent = JSON.stringify(variants);
      picker.variantData = variants;
      picker.dataset.eoneVariantsReady = 'true';
    });
  }

  // Retain the theme's own swatch, availability, image and quick-add updates.
  document.addEventListener('change', async event => {
    const picker = event.target.closest('card-variant-selects[data-eone-lazy-variants]');
    if (!picker || picker.dataset.eoneVariantsReady === 'true') return;
    event.stopImmediatePropagation();
    const sequence = picker.eoneSequence = (picker.eoneSequence || 0) + 1;
    picker.setAttribute('aria-busy', 'true');
    const card = picker.closest('.card-wrapper');
    const quickAdd = card && card.querySelector('[data-product-url]');
    if (sequence === 1 && quickAdd) picker.eoneQuickAddDisabled = quickAdd.disabled;
    if (quickAdd) quickAdd.disabled = true;
    let replay = false;
    try {
      await hydrate(picker);
      if (!picker.isConnected || sequence !== picker.eoneSequence) return;
      picker.querySelector('[data-eone-option-error]')?.remove();
      replay = true;
    } catch (error) {
      if (sequence !== picker.eoneSequence) return;
      if (!picker.querySelector('[data-eone-option-error]')) {
        const message = document.createElement('p');
        message.dataset.eoneOptionError = '';
        message.setAttribute('role', 'status');
        message.textContent = 'Options could not load. ';
        const link = document.createElement('a');
        link.href = picker.dataset.url;
        link.textContent = 'View product options';
        message.appendChild(link);
        picker.appendChild(message);
      }
    } finally {
      if (sequence === picker.eoneSequence) {
        picker.removeAttribute('aria-busy');
        if (quickAdd) quickAdd.disabled = picker.eoneQuickAddDisabled;
      }
    }
    if (replay) event.target.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);
})();
